import React, { useMemo, useState } from "react";
import { insertPing } from "../lib/pings";
import { cx, ui } from "../ui/ui";

const KINDS = [
  { kind: "thinking_of_you", label: "Thinking of you", emoji: "💭" },
  { kind: "need_hug", label: "Need a hug", emoji: "🫂" },
  { kind: "you_got_this", label: "You got this", emoji: "💪" },
  { kind: "flirty", label: "Flirty", emoji: "😏" },
  { kind: "grateful", label: "Grateful", emoji: "🙏" },
  { kind: "tired", label: "Tired", emoji: "😴" },
];

function clampNote(s) {
  const v = String(s || "");
  return v.length > 140 ? v.slice(0, 140) : v;
}

export default function PingGrid({ onSent }) {
  const [note, setNote] = useState("");
  const [status, setStatus] = useState("");
  const [sendingKind, setSendingKind] = useState("");

  const disabled = useMemo(() => Boolean(sendingKind), [sendingKind]);

  async function send(kind) {
    setStatus("");
    setSendingKind(kind);

    const clean = clampNote(note).trim();

    const { error } = await insertPing({
      kind,
      note: clean || null,
    });

    setSendingKind("");
    if (error) {
      setStatus(error.message || "Failed to send ping.");
      return;
    }

    setNote("");
    setStatus("Sent 🦦");
    window.setTimeout(() => setStatus(""), 800);
    onSent?.();
  }

  return (
    <div className="grid gap-3">
      <label className="grid gap-2">
        <div className="flex items-center justify-between">
          <span className={ui.label}>Optional note</span>
          <span className="text-xs text-white/50">{clampNote(note).length}/140</span>
        </div>
        <input
          className={ui.input}
          placeholder="Add a quick note…"
          value={note}
          onChange={(e) => setNote(clampNote(e.target.value))}
          maxLength={140}
          disabled={disabled}
        />
      </label>

      <div className="grid grid-cols-2 gap-2">
        {KINDS.map((k) => {
          const active = sendingKind === k.kind;
          return (
            <button
              key={k.kind}
              onClick={() => send(k.kind)}
              disabled={disabled}
              className={cx(
                "group rounded-2xl border border-line2 bg-white/5 px-3 py-3 text-left transition",
                "hover:bg-white/10 active:scale-[0.99]",
                active ? "ring-2 ring-otter/25 border-white/25" : "",
                disabled && !active ? "opacity-60 cursor-not-allowed" : ""
              )}
            >
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-2xl border border-line bg-black/10 grid place-items-center">
                  <span className="text-lg">{k.emoji}</span>
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-black tracking-tight truncate">{k.label}</div>
                  <div className="text-xs text-white/60 truncate">{k.kind}</div>
                </div>
              </div>
            </button>
          );
        })}
      </div>

      {status ? <div className="text-sm text-white/80">{status}</div> : null}
    </div>
  );
}
